import React, { useEffect } from "react";
import ListingPage from "../../components/ListingPage";
import PageHeader from "../../components/PageHeader";
import { useLocation } from "react-router-dom";
import { useData } from "../../contexts/DataContext";
import { MissingTimesheets_Table_Header } from "./TimeSheetListTable";
import TimeSheetAPI from "../../services/TimeSheetService";

export default function MissingTimesheets({
  isProxyTimesheet,
  proxyEmpId,
  proxyEmpEmail
}) {
  const location = useLocation();
  const { employeeId } = location.state || {};
  const { userData } = useData();

  const weekWiseTimesheetPage = true;
  const MissingTimesheetsPage = true;
  const column = MissingTimesheets_Table_Header;
  function fetchMissingTimesheets(axiosPrivate, pageNumber, pageSize) {
    const payload = {
      employee_email: isProxyTimesheet
        ? proxyEmpEmail
        : userData?.user_info?.email,
      is_proxy: Boolean(isProxyTimesheet)
    };

    return TimeSheetAPI.MISSING_TIMESHEETS(
      axiosPrivate,
      payload,
      pageNumber,
      pageSize
    );
  }

  return (
    <>
      {!isProxyTimesheet && (
        <PageHeader
          primaryTitle={"Missing Timesheets"}
          showBack={true}
          showSecondaryTitle={false}
        />
      )}

      <ListingPage
        isProxyTimesheet={isProxyTimesheet}
        proxyEmpEmail={proxyEmpEmail}
        proxyEmpId={proxyEmpId}
        column={column}
        fetchListAPI={fetchMissingTimesheets}
        employeeId={isProxyTimesheet ? proxyEmpId : employeeId}
        weekWiseTimesheetPage={weekWiseTimesheetPage}
        MissingTimesheetsPage={MissingTimesheetsPage}
      />
    </>
  );
}
